import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import LockOutlineRoundedIcon from "@mui/icons-material/LockOutlineRounded";
import { Button, Stack } from "@mui/material";
import { useEffect, useMemo } from "react";
import { Outlet, useNavigate } from "react-router";
import useClientContext from "../../../context/useClientContext.ts";
import EditableTitle from "../../common/EditableTitle";
import GeneralPageHeader from "../../common/GeneralPageHeader";
import CanvasView from "./CanvasView";
import { useDashboardContext } from "./contexts/DashboardContext";

const DashboardPageView = () => {
  const { dashboard, tileObjects, setIsEditMode } = useDashboardContext();
  const navigate = useNavigate();
  const { hasAnyPermission } = useClientContext();
  const hasAccessToManageDashboards = useMemo(() => hasAnyPermission(["ManageDashboards"]), [hasAnyPermission]);

  useEffect(() => {
    setIsEditMode(false);
    // eslint-disable-next-line @eslint-react/exhaustive-deps
  }, []);

  const handleEditDashboard = () => {
    navigate(`../edit`);
  };

  return (
    <>
      <GeneralPageHeader
        TitleComponent={
          <EditableTitle
            title={dashboard?.nameUserInput ?? ""}
            tooltip="Rename Dashboard"
            editingDisabled
            placeholder="Enter Dashboard Name"
          />
        }
        showDefaultBackButtonTo="../.."
      >
        <Button variant="outlined" color="secondary" disabled startIcon={<LockOutlineRoundedIcon />}>
          Share
        </Button>
        {hasAccessToManageDashboards && (
          <Button variant="outlined" color="secondary" startIcon={<EditOutlinedIcon />} onClick={handleEditDashboard}>
            Edit
          </Button>
        )}
      </GeneralPageHeader>
      <Stack direction="row" sx={{ flex: 1 }}>
        <Stack sx={{ flex: 1, backgroundColor: "background.grey" }}>
          <CanvasView tiles={tileObjects} />
        </Stack>
      </Stack>
      <Outlet />
    </>
  );
};

export default DashboardPageView;
